function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_257",
  "data-name": "Group 257",
  transform: "translate(-4296.515 -1147.515)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_56",
  "data-name": "Rectangle 56",
  width: 22,
  height: 2,
  rx: 1,
  transform: "translate(4313.485 1148.929) rotate(135)",
  fill: "#72638c"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_57",
  "data-name": "Rectangle 57",
  width: 22,
  height: 2,
  rx: 1,
  transform: "translate(4297.929 1147.515) rotate(45)",
  fill: "#72638c"
}));

function SvgNavbarHamburgerClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.971,
    height: 16.971,
    viewBox: "0 0 16.971 16.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarHamburgerClose);
export default __webpack_public_path__ + "static/media/navbar-hamburger-close.ee528f9d80ef41eaebe5d566513f84e3.svg";
export { ForwardRef as ReactComponent };